import { useEffect } from 'react';
import { Stack, Title, Text } from '@repletoryreach/sdk-ui';
import { Link, useSearchParams } from 'react-router-dom';
import { SignupForm } from './components/SignupForm';
import { SocialButtons } from '../components/SocialButtons';
import { SIGNUP_PLAN_KEY } from '../../billing/components/PlanCard';
import { SIGNUP_REF_KEY, SIGNUP_PARTNER_KEY } from '../../refer/components/ReferralCodeField';
import { useT } from '../../../i18n/I18nProvider';

export default function SignupPage() {
  const t = useT();
  const [params] = useSearchParams();
  // "Pick Growth" on the public site lands here with ?plan=growth. The billing
  // page opens the plan chooser on it once the organisation exists.
  const plan = params.get('plan');
  useEffect(() => {
    if (!plan) return;
    try { sessionStorage.setItem(SIGNUP_PLAN_KEY, plan); } catch { /* storage may be unavailable */ }
  }, [plan]);

  // W47: a partner's link lands here with ?ref=CODE. The form prefills from
  // this, and `?partner=1` from the partners page means the person came to
  // sell the product rather than to use it, so onboarding ends on Refer and
  // earn instead of the dashboard.
  const ref = params.get('ref');
  const partner = params.get('partner');
  useEffect(() => {
    try {
      if (ref) sessionStorage.setItem(SIGNUP_REF_KEY, ref);
      if (partner) sessionStorage.setItem(SIGNUP_PARTNER_KEY, '1');
    } catch { /* storage may be unavailable */ }
  }, [ref, partner]);
  return (
    <Stack gap="lg">
      <Stack gap="xs">
        <Title order={1}>{t('auth.signup.title')}</Title>
        <Text role="bodySmall" c="var(--rr-color-text-muted)">
          {t('auth.signup.description')}
        </Text>
      </Stack>
      <SignupForm />
      <SocialButtons />
      <Text role="caption" c="var(--rr-color-text-muted)">
        {t('auth.signup.haveAccount')} <Link to="/auth/login">{t('action.signIn')}</Link>
      </Text>
    </Stack>
  );
}
